<script setup lang="ts">
const { getBranchColor, getBranchLabel } = useBranches();

const props = defineProps<{
  title: string
  icon: string
  total: number
  byBranch: Record<string, number>
  formatter?: (value: number) => string
}>();

// Transform branch data into progress list items
const progressItems = computed(() => {
  return Object.entries(props.byBranch).map(([branch, value]) => ({
    title: getBranchLabel(branch),
    color: getBranchColor(branch),
    value: value
  }));
});

// Format total value using formatter if provided
const formattedTotal = computed(() => {
  if (props.formatter) {
    return props.formatter(props.total);
  }
  return new Intl.NumberFormat("tr-TR").format(props.total);
});
</script>

<template>
  <AppCard :title="title" :icon="icon">
    <template #right>
      <span class="text-lg font-bold">
        {{ formattedTotal }}
      </span>
    </template>

    <ProgressList :items="progressItems" :formatter="props.formatter" />
  </AppCard>
</template>
